<div class="wizard-container">
  <h2 class="text-center mb-4">Nueva Entrega de Corderos</h2>

  <!-- Indicador de progreso -->
  <div class="progress mb-4">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width.%]="(pasoActual / 3) * 100"
      [attr.aria-valuenow]="pasoActual"
      aria-valuemin="1"
      aria-valuemax="3"
    >
      Paso {{ pasoActual }} de 3
    </div>
  </div>

  <!-- Paso 1: Cantidades -->
  <div *ngIf="pasoActual === 1" class="step-content">
    <h3 class="mb-3">1. Cantidades de Corderos</h3>

    <div class="form-group">
      <label for="machos">Cantidad de Corderos MACHOS:</label>
      <input
        type="number"
        class="form-control"
        id="machos"
        [(ngModel)]="entregaData.machos"
        (ngModelChange)="actualizarTotal()"
        placeholder="Inserte la cantidad"
        min="0"
        required
      />
    </div>

    <div class="form-group">
      <label for="hembras">Cantidad de Corderos HEMBRAS:</label>
      <input
        type="number"
        class="form-control"
        id="hembras"
        [(ngModel)]="entregaData.hembras"
        (ngModelChange)="actualizarTotal()"
        placeholder="Inserte la cantidad"
        min="0"
        required
      />
    </div>

    <div class="form-group">
      <label for="total">Total Corderos:</label>
      <input
        type="number"
        class="form-control"
        id="total"
        [value]="entregaData.total"
        readonly
      />
    </div>
    <!-->
    <div class="form-group">
      <label for="observaciones">Observaciones:</label>
      <textarea
        class="form-control"
        id="observaciones"
        [(ngModel)]="entregaData.observaciones"
        rows="3"
        placeholder="Escriba sus observaciones aquí"
      ></textarea>
    </div>

  -->
    <div class="d-flex justify-content-between mt-4">
      <div></div>
      <button
        class="btn btn-primary"
        (click)="siguientePaso()"
        [disabled]="!cantidadesValidas()"
      >
        Siguiente <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Paso 2: Finca -->
  <div *ngIf="pasoActual === 2" class="step-content">
    <h3 class="mb-3">1. Cliente y Finca de Destino</h3>
    <div class="form-group mb-3">
      <label for="cliente">Seleccione el cliente:</label>
      <select
        id="cliente"
        class="form-control"
        [(ngModel)]="clienteSeleccionado"
        (change)="clienteSeleccionadoCambio()"
        required
      >
        <option value="0" disabled selected>Seleccione un cliente...</option>
        <option *ngFor="let cli of clientes" [value]="cli.ttSocio">
          {{ cli.ttNombr }}
        </option>
      </select>
    </div>
    <h3 class="mb-3">2. Finca de Destino</h3>

    <div class="form-group">
      <label for="finca">INDIQUE LA FINCA DE LA ENTREGA:</label>
      <select
        class="form-control"
        id="finca"
        [(ngModel)]="entregaData.finca"
        required
      >
        <option value="" disabled selected>Seleccione una finca...</option>
        <option *ngFor="let f of fincas" [value]="f.ttcodexp">
          {{ f.ttdescr }} - {{ f.ttpoblac }} - {{ f.ttcodexp }}
        </option>
      </select>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-secondary" (click)="anteriorPaso()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Anterior
      </button>
      <button
        class="btn btn-primary"
        (click)="siguientePaso()"
        [disabled]="!fincaValida()"
      >
        Siguiente <fa-icon [icon]="faArrowRight"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Paso 3: Quién recoge -->
  <div *ngIf="pasoActual === 3" class="step-content">
    <h3 class="mb-3">3. ¿Recogida?</h3>

    <div class="form-group">
      <label for="recoge">Seleccione:</label>
      <select
        id="recoge"
        class="form-control"
        [(ngModel)]="entregaData.recoger"
      >
        <option [ngValue]="0">SI</option>
        <option [ngValue]="1">NO</option>
        <option [ngValue]="2">COOP</option>
      </select>
    </div>

    <div class="d-flex justify-content-between mt-4">
      <button class="btn btn-secondary" (click)="anteriorPaso()">
        <fa-icon [icon]="faArrowLeft"></fa-icon> Anterior
      </button>
      <button
        class="btn btn-success"
        (click)="enviarEntrega()"
        [disabled]="resul"
      >
        <span *ngIf="!resul">Enviar Entrega</span>
        <span *ngIf="resul">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Enviando...
        </span>
      </button>
    </div>
  </div>
</div>
